/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:07:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-03 16:40:13
 */
import axios from "axios";
import qs from "qs";
import crypto from "@/utils/crypto.js";
// 引入路由
import router from "../router";

// 引入弹框组件
import { message } from 'ant-design-vue';

// 请求接口域名地址
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
// 请求拦截器 统一携带token
axios.interceptors.request.use(config => {
  // 请求头携带token
  config.headers.token = sessionStorage.getItem('token');
  return config;
});

// 响应拦截器
axios.interceptors.response.use(
  res => {
    if (res) {
      // 如果响应的数据含有code字段和msg字段
      if (
        res.data !== undefined &&
        res.data.code !== undefined &&
        res.data.msg !== undefined
      ) {
        // 解构出来
        let { code, msg } = res.data;

        // 如果成功 弹出成功提示
        if (code != 0) {
          message.error(msg);
        }
      }
      return res;
    }
  },
  err => {
    if (err.response.data.code === 401) {
      message.error("无效的token，请重新登录");
      // 错误跳转到登录页
      router.push("/login");
    }
    if(err.response.data.code === 403){
       // 错误跳转到无权限页面
       message.error("没有该权限");
       router.push("/index/403");
    }
    if(err.response.data.code === 500){
      message.error("网络错误");
    }
  }
);

const initialDecryption = ()=>{
  return JSON.parse(crypto.decrypt(localStorage.getItem('secret'),'1234567890123456','1234561234567890'));
}

export default {
  get(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params
        })
        .then(res => {
          if (res) {
            if(url == '/manager-service/get-api-auth'){
              resolve(res.data);
            }else{
              resolve(res.data);
            }
            
          }
        })
        .catch(err => {
          reject(err); //失败
        });
    });
  },
  post(url, params = {}) {
    // 加密
    const {iv,key,requestEnable,responseEnable} =  initialDecryption();
    if(requestEnable && Object.keys(params).length > 0){
      params = {
        data:crypto.encryption(JSON.stringify(params),key,iv),
     }
    }
    return new Promise((resolve, reject) => {
      axios
      .post(url, params,{headers: {'Content-Type': 'application/json'}})
        .then(res => {
          if (res) {
            // 对于返回数据 解密
            if(responseEnable){ // 响应需要解密
              res.data.data = JSON.parse(crypto.decrypt(res.data.data,key,iv))
              resolve(res.data);
            }
            resolve(res.data); // 成功
          }
        })
        .catch(err => {
          console.log(err,'没有抓到');
          reject(err); // 失败
        });
    });
  },
  file(url, params = {}) {
    // 加密
    let array = ['/site-service/m/cover/uploadImage','/site-service/m/cover/uploadVideo'];
    const {iv,key,requestEnable,responseEnable} =  initialDecryption();
    if(array.indexOf(url) == -1){
      if(requestEnable && Object.keys(params).length > 0){
        params = {
          data:crypto.encryption(JSON.stringify(params),key,iv),
      }
      }
    }
    return new Promise((resolve, reject) => {
      axios
      .post(url, params,{headers: {'Content-Type': 'multipart/form-data'}})
        .then(res => {
          if (res) {
            // 对于返回数据 解密
            if(array.indexOf(url) == -1){
              if(responseEnable){ // 响应需要解密
                res.data.data = JSON.parse(crypto.decrypt(res.data.data,key,iv))
                resolve(res.data);
              }
            }
            resolve(res.data); // 成功
          }
        })
        .catch(err => {
          console.log(err,'没有抓到');
          reject(err); // 失败
        });
    });
  },
  down(url, params = {}) {
    // 加密
    let nameData = params;
    const {iv,key,requestEnable,responseEnable} =  initialDecryption();
    if(requestEnable && Object.keys(params).length > 0){
      params = {
        data:crypto.encryption(JSON.stringify(params),key,iv),
     }
    }
    return new Promise((resolve, reject) => {
      axios.post(url, params,{responseType: 'blob',headers: {'Content-Type': 'application/json'}},nameData)
        .then(res => {
          if (res) {
            var blob = new Blob([res.data],{type: res.headers['content-type']});
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = nameData.fileName?nameData.fileName+'.xlsx':"意见清单.xlsx"; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            resolve(res.data); // 成功
          }
        })
        .catch(err => {
          reject(err); // 失败
        });
    });
  },
  put(url, params={}) {
    return new Promise((resolve, reject) => {
      axios.put(url, params)
        .then(res => {
          if (res) {
            resolve(res.data); // 成功
          }
        })
        .catch(err => {
          reject(err) // 失败
        })
    });
  },
  delete(url, params={}) {
    return new Promise((resolve, reject) => {
      axios.delete(url, params)
        .then(res => {
          if (res) {
            resolve(res.data); // 成功
          }
        })
        .catch(err => {
          reject(err)
        })
    });
  }
};
